<template>
  <div>
    <verify-mess v-transition></verify-mess>
  </div>
</template>

<script>
import VerifyMess from './components/Mess'
export default {
  name: 'Detail',
  components: {
    VerifyMess
  },
  methods: {
    getPayInfo () {
      this.axios.get('/ApiOrderPay/PermissionValidation', {
        params: {
          oid: decodeURIComponent([this.$route.query.oid]),
          id: decodeURIComponent([this.$route.query.id])
        }
      }).then(this.getPayInfoSucc)
        .catch(this.getPayInfoFail)
    },
    getPayInfoSucc (res) {
      res = res.data
      if (res.ret) {
        if (res.errorInfo !== '') {
          if (res.errorInfo.indexOf('未设置支付密码') >= 0) {
            alert(res.errorInfo)
            this.$router.push({
              path: '/revise_pay_password_validate'
            })
          } else {
            alert(res.errorInfo)
          }
        }
      }
    },
    getPayInfoFail (err) {
      alert(err)
    }
  },
  mounted () {
    this.getPayInfo()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/identify_verify/Verify.vue